import { Directive , AfterViewInit, ElementRef, Input,Renderer2, input} from '@angular/core';

@Directive({
  selector: '[text-length-overflow]',
  standalone: false
})
export class EllipsesTooltipDirective  implements AfterViewInit{
  @Input('text-length-overflow') maxLength: number | null = null;

  constructor(private el:ElementRef, private renderer:Renderer2) { }

  ngAfterViewInit(): void {
    this.applyTruncation();
  }
  private applyTruncation(){
    const text = this.el.nativeElement.textContent.trim();
    if(this.maxLength && text.length > this.maxLength){
      const truncatedText = text.substring(0, this.maxLength) + '....';
      this.renderer.setProperty(this.el.nativeElement, 'textContent', truncatedText);
      this.renderer.setAttribute(this.el.nativeElement, 'title', text);
    }
  }
}
